import { render, staticRenderFns } from "./dataitem.vue?vue&type=template&id=8c6ae55a&scoped=true&"
import script from "./dataitem.vue?vue&type=script&lang=js&"
export * from "./dataitem.vue?vue&type=script&lang=js&"
import style0 from "./dataitem.vue?vue&type=style&index=0&id=8c6ae55a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6ae55a",
  null
  
)

export default component.exports